import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import axios from 'axios';
import LiveDataQuery from '../hooks/LiveDataQuery';

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = React.useState(null);
  const [userOrganization, setUserOrganization] = React.useState(null);

  React.useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await axios.get('/api/auth/validate-token', { withCredentials: true });
        setIsAuthenticated(true);
        setUserOrganization(response.data.user.organization);
      } catch (error) {
        setIsAuthenticated(false);
      }
    };
    checkAuth();
  }, []);

  return { isAuthenticated, userOrganization };
};

const ProtectedRoute = () => {
  const { isAuthenticated, userOrganization } = useAuth();
  const { liveData, isLoading } = LiveDataQuery();

  // Debugging output
  console.log("ProtectedRoute: User organization:", userOrganization);
  console.log("ProtectedRoute: Live data loading:", isLoading);

  if (isAuthenticated === null || isLoading) return <div>Loading...</div>;
  if (!isAuthenticated) return <Navigate to="/signin" replace />;

  return <Outlet context={{ liveData, userOrganization }} />;
};

export default ProtectedRoute;
